import { Component, EventEmitter, Input, OnInit, DoCheck, Output } from "@angular/core";
import { Tab } from "../../models/tabs/tabs";

@Component({
    selector: "app-tabbed-content",
    templateUrl: "./tabbed-content.component.html",
    styleUrls: ["./tabbed-content.component.scss"],
})
export class TabbedContentComponent implements DoCheck {
    @Input() tabs: Tab[];
    @Input() pageTitle: string;
    @Output() emitSelectedTab: EventEmitter<Tab> = new EventEmitter<Tab>();

    public selectedTab: Tab;

    ngDoCheck(): void {
        this.selectedTab = this.tabs.find((tab) => tab.isSelected);
        this.emitSelectedTab.emit(this.selectedTab);
    }

    public setSelectedTab(tabText: string) {
        const tabToSelect = this.tabs.find(
            (tab: Tab) => tab.tabText === tabText
        );
        const priorSelectedTab = this.tabs.find((tab: Tab) => tab.isSelected);

        if (tabToSelect !== priorSelectedTab) {
            priorSelectedTab.isSelected = false;
            tabToSelect.isSelected = true;
            this.selectedTab = tabToSelect;
            this.emitSelectedTab.emit(this.selectedTab);
        }
    }
}
